// 系统支持的语言列表
// 当前系统使用 value 作为语言标识
// elementValue dayjs 统一用elementValue
// 如有新增三方库需要适配多语言，应该在语言切换事件内处理 changeLibraryLocale
export const languageConfigList = [
  {
    name: '简体中文',
    text: '简体中文',
    value: 'zh_CN',
  },
  {
    name: '繁体中文',
    text: '繁体中文',
    value: 'zh_TW',
  },
  {
    name: '英语',
    text: 'English',
    value: 'en_US',
  },
  {
    name: '韩语',
    text: '한국어',
    value: 'ko_KR',
  },
  {
    name: '越南语',
    text: 'Tiếng Việt',
    value: 'vi_VN',
  },
  {
    name: '泰语',
    text: 'ภาษาไทย',
    value: 'th_TH',
  },
  {
    name: '土耳其语',
    text: 'Türkçe',
    value: 'tr_TR',
  },
  {
    name: '西班牙语',
    text: 'Español',
    value: 'es_ES',
  },
  {
    name: '葡萄牙语',
    text: 'Português',
    value: 'pt_PT',
  },
  {
    name: '日语',
    text: '日本語',
    value: 'ja_JP',
  },
  {
    name: '朝鲜语',
    text: '한국어',
    value: 'ko_KP',
  },
]

// 语言标识匹配文案 - 对象 { zh_CN: 'language.lang_1' }
const getLangTextMap = () => {
  let _langTextMap = {}
  languageConfigList.forEach((item) => {
    _langTextMap[item.value] = item.text
  })
  return _langTextMap
}
export const langTextMap = getLangTextMap()

// language selects for user
export const initialLanguageArr = [
  {
    langValue: 'en_US',
    langName: langTextMap['en_US'],
  },
  {
    langValue: 'es_ES',
    langName: langTextMap['es_ES'],
  },
  {
    langValue: 'ko_KP',
    langName: langTextMap['ko_KP'],
  },
  {
    langValue: 'pt_PT',
    langName: langTextMap['pt_PT'],
  },
  {
    langValue: 'th_TH',
    langName: langTextMap['th_TH'],
  },
  {
    langValue: 'tr_TR',
    langName: langTextMap['tr_TR'],
  },
  {
    langValue: 'vi_VN',
    langName: langTextMap['vi_VN'],
  },
  {
    langValue: 'zh_TW',
    langName: langTextMap['zh_TW'],
  },
]

/* xlsx config */
// xlsx 新增
export const xlsxNameList = [
  {
    name: 'GeaExplorer',
    value: 'GeaExplorer',
  },
  {
    name: 'GeaExplorerType',
    value: 'GeaExplorerType',
    type: 'Enum', // 枚举类型
  },
]

// i18n config
export const i18nConfig = {
  defaultLang: 'en_US', // 默认
  fallbackLng: ['en_US'], // 备选语言。当前语言不可用时
  langLocalName: 'language',
}
